import { render } from "./mAndService.vue?vue&type=template&id=73c0b24c&scoped=true"
import script from "./mAndService.vue?vue&type=script&lang=js"
export * from "./mAndService.vue?vue&type=script&lang=js"

import "./mAndService.vue?vue&type=style&index=0&id=73c0b24c&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73c0b24c"]])

export default __exports__